import { createWire } from '@forminator/react-wire'

export const atrPackets = createWire([])
